import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import {
    Switch,
    Route,
} from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ConnectedRouter } from 'connected-react-router';
// translate message
import languageObject from '../../translations/messages';
// component
import ErrorPage from './ErrorPage';
import HomePage, { HomeHeader } from '../../containers/home/Home';
import Login from '../../containers/login/Login';
import LoginSubAdmin from '../../containers/login/LoginSubAdmin';
import UserLogin from '../../containers/login/UserLogin';
import SettingBooth from '../../containers/admin/SettingBooth/SettingBooth';
import ListEvents from '../../containers/admin/EventManagement/ListEvent';
import SettingSeminarRoom from '../../containers/admin/SettingSeminarRoom/SettingSeminarRoom';
import CompanyEventManagement from '../../containers/admin/EventManagement/CompanyEventManagement';
import ListOrganizer from '../../containers/admin/OrganizerManagement/ListOrganizer';
import DetailCompany from '../../containers/admin/CompanyManagement/DetailCompany';
import ListProductExhibition from '../../containers/admin/CompanyManagement/ListProductExhibition';
import ProductManagement from '../../containers/productManagement/ProductManagement';
import ProductManagementPreview from '../../containers/productManagement/ProductManagementPreview';
import ProductRegister from '../../containers/productRegister/ProductRegister';
import AdvertisememtRegister from '../../containers/advertisementRegister/AdvertisementRegister';
import ListViewer from '../../containers/admin/ViewerManagement/ListViewer';
import ListSeminars from '../../containers/admin/CompanyManagement/ListSeminar';
import DetailCompanyOrganizer from '../../containers/companyManagementOrganizer/DetailCompanyOrganizer';
import ListSeminar from '../../containers/SeminarManagementOrganizer/ListSeminar';
import ListSeminarPreview from '../../containers/SeminarManagementOrganizer/ListSeminarPreview';
import OrganizerList, { HeaderOrganizerList } from '../../containers/organizerList/OrganizerList';
import OrganizerPosterList, { OrganizerPosterHeader } from '../../containers/organizerList/OrganizerPosterList';
import ProductListOnDisplay, { ProductListOnDisplayHeader } from '../../containers/ProductListOnDisplay/ProductListOnDisplay';
import ListSeminarViewer, { ListSeminarHeader } from '../../containers/SeminarManagementViewer/ListSeminarViewer';
import ListSeminarViewerNonAuth, { ListSeminarViewerNonAuthHeader } from '../../containers/SeminarManagementViewer/ListSeminarViewerNonAuth';
import DetailSeminarViewer, { DetailSeminarHeader } from '../../containers/SeminarManagementViewer/DetailSeminar';
import ListSeminarRegistered, { ListSeminarRegisteredHeader } from '../../containers/SeminarRegisteredManagermentViewer/ListSeminarRegistered';
import DetailSeminarRegistered, { DetailSeminarRegisteredHeader } from '../../containers/SeminarRegisteredManagermentViewer/DetailSeminarRegistered';
import SurverManagement from '../../containers/admin/SurveyManagement/SurveyManagement';
import AdvertisementManagement from '../../containers/admin/AdvertisementManagement/AdvertisementManagement';
import ListLiveStream from '../../containers/admin/CompanyManagement/ListLiveStream';
import ListRegisterSeminar from '../../containers/admin/RegisterSeminarManagerment/ListRegisterSeminar';
import FAQ, { QAHeader } from '../../containers/faq/FAQ';
import QAListManagerment from '../../containers/admin/QAListManagerment/QAListManagerment';
import VisitHistoryManagement from '../../containers/admin/VisitHistoryManagement/VisitHistoryManagement';
import ListAllSeminar from '../../containers/admin/SeminarManagement/ListAllSeminar';
import LiveStreamManagement from '../../containers/admin/LiveStreamManagement/LiveStreamManagement';
import SettingShoppingCart from '../../containers/admin/SettingShoppingCart/SettingShoppingCart';
import OrderProductPaymentManagement from '../../containers/admin/OrderProductPaymentManagement/OrderProductPaymentManagement';
import ListRegisterLiveStream from '../../containers/admin/RegisterLiveStreamManagement/RegisterLiveStreamManagement';
import SettingSellProductOrganizer from '../../containers/SettingSellProductOrganizer/SettingSellProductOrganizer';
import ListLivestreamRegistered, { ListLivestreamRegisteredHeader } from '../../containers/LivestreamRegisteredManagementViewer/ListLivestreamRegistered';
import DetailLivestreamRegistered, { DetailLivestreamRegisteredHeader } from '../../containers/LivestreamRegisteredManagementViewer/DetailLivestreamRegistered';
import CartViewer, { CartViewerHeader } from '../../containers/cartViewer/CartViewer';

// common layout
import AdminLayout from './AdminLayout';
import UserLayout from './UserLayout';
import ViewerLayout from './ViewerLayout';

import RegistrationViewer from '../../containers/home/RegistrationViewer';
import RegistrationOrganizer from '../../containers/home/RegistrationOrganizer';

/**
 * list routes
 */
import baseSystems from '../../components/SideBar/SystemRoutes';
import eventManagementSystem from '../../components/SideBar/EventManagementRoutes';
import companyMangementSystem from '../../components/SideBar/CompanyMangementSystem';
import userRoutes from './UserRoutes';
import organizerRoutes from './OrganizerRoutes';
import ListLiveStreamViewer, { ListLiveStreamHeader } from '../../containers/LiveStreamViewer/ListLiveStreamViewer';
import ListLiveStreamOrganizer from '../../containers/LiveStreamOrganizer/ListLiveStreamOrganizer';
import PageVideoLiveStream from '../../containers/LiveStreamViewer/PageVideoLiveStream';
import OuterServerMail from '../../containers/admin/OuterServerMail/OuterServerMail';
import SettingProductCompany from '../../containers/admin/SettingProductCompany/SettingProductCompany';
import SettingCustom from '../../containers/admin/SettingCustom/SettingCustom';
import ListLiveStreamOrganizerPreview from '../../containers/LiveStreamOrganizer/ListLiveStreamOrganizerPreview';
import SettingMultiLanguage from '../../containers/admin/SettingMultiLanguage/SettingMultiLanguage';

const App = (props) => {
    const {
        locale,
        history,
        getListOptionsRequested,
    } = props;

    useEffect(() => {
        getListOptionsRequested({ language: locale });
    }, [locale]);

    return (
        <>
            <ConnectedRouter history={history}>
                <IntlProvider locale={locale} messages={languageObject[locale]}>
                    <Switch>
                        {/* another router */}
                        <Route exact path={[`/${process.env.REACT_APP_ROOT_PATH_LOGIN_ADMIN}/`]}>
                            <Switch>
                                <Route
                                    path={`/${process.env.REACT_APP_ROOT_PATH_LOGIN_ADMIN}/`}
                                    exact
                                    component={Login}
                                />
                            </Switch>
                        </Route>

                        {/* another router, login account sub admin */}
                        <Route exact path={[`/${process.env.REACT_APP_ROOT_PATH_LOGIN_SUB_ADMIN}/`]}>
                            <Switch>
                                <Route
                                    path={`/${process.env.REACT_APP_ROOT_PATH_LOGIN_SUB_ADMIN}/`}
                                    exact
                                    component={LoginSubAdmin}
                                />
                            </Switch>
                        </Route>

                        {/* viewer router without background header */}
                        <Route
                            exact
                            path={[
                                '/:shortName/home',
                                '/:shortName/visitor_login',
                                '/:shortName/exhibitor_login',
                                '/:shortName/register-visitor',
                                '/:shortName/register-exhibitor',
                                '/:shortName/exhibitors',
                                '/:shortName/exhibitor-posters',
                                '/:shortName/:companyId/products',
                                '/:shortName/seminars',
                                '/:shortName/list-seminar',
                                '/:shortName/seminars/:id',
                                '/:shortName/seminar_registered',
                                '/:shortName/seminar_registered/:seminarId',
                                '/:shortName/QA',
                                '/:shortName/live_stream',
                                '/:shortName/live_stream/:id',
                                '/:shortName/live-stream-registered',
                                '/:shortName/live-stream-registered/:id',
                                '/:shortName/shopping-cart',
                            ]}
                        >
                            <ViewerLayout routes={userRoutes} seo>
                                <Switch>
                                    <Route path="/:shortName/home" exact>
                                        <HomeHeader />
                                        <HomePage />
                                    </Route>
                                    <Route path="/:shortName/visitor_login" exact>
                                        <HomeHeader />
                                        <UserLogin />
                                    </Route>
                                    <Route path="/:shortName/exhibitor_login" exact>
                                        <HomeHeader />
                                        <UserLogin />
                                    </Route>
                                    <Route path="/:shortName/register-visitor" exact>
                                        <HomeHeader />
                                        <RegistrationViewer />
                                    </Route>
                                    <Route path="/:shortName/register-exhibitor" exact>
                                        <HomeHeader />
                                        <RegistrationOrganizer />
                                    </Route>
                                    <Route path="/:shortName/exhibitors" exact>
                                        <HeaderOrganizerList />
                                        <OrganizerList />
                                    </Route>
                                    <Route path="/:shortName/exhibitor-posters" exact>
                                        <OrganizerPosterHeader />
                                        <OrganizerPosterList />
                                    </Route>
                                    <Route path="/:shortName/:companyId/products" exact>
                                        <ProductListOnDisplayHeader />
                                        <ProductListOnDisplay />
                                    </Route>
                                    <Route path="/:shortName/seminars" exact>
                                        <ListSeminarHeader />
                                        <ListSeminarViewer />
                                    </Route>
                                    <Route path="/:shortName/seminars/:id" exact>
                                        <DetailSeminarHeader />
                                        <DetailSeminarViewer />
                                    </Route>
                                    <Route path="/:shortName/list-seminar" exact>
                                        <ListSeminarViewerNonAuthHeader />
                                        <ListSeminarViewerNonAuth />
                                    </Route>
                                    <Route path="/:shortName/seminar_registered" exact>
                                        <ListSeminarRegisteredHeader />
                                        <ListSeminarRegistered />
                                    </Route>
                                    <Route path="/:shortName/seminar_registered/:seminarId" exact>
                                        <DetailSeminarRegisteredHeader />
                                        <DetailSeminarRegistered />
                                    </Route>
                                    <Route path="/:shortName/QA" exact>
                                        <QAHeader />
                                        <FAQ />
                                    </Route>
                                    <Route path="/:shortName/live_stream" exact>
                                        <ListLiveStreamHeader />
                                        <ListLiveStreamViewer />
                                    </Route>
                                    <Route path="/:shortName/live_stream/:id" exact>
                                        <ListLiveStreamHeader />
                                        <PageVideoLiveStream />
                                    </Route>
                                    <Route path="/:shortName/live-stream-registered" exact>
                                        <ListLivestreamRegisteredHeader />
                                        <ListLivestreamRegistered />
                                    </Route>
                                    <Route path="/:shortName/live-stream-registered/:id" exact>
                                        <DetailLivestreamRegisteredHeader />
                                        <DetailLivestreamRegistered />
                                    </Route>
                                    <Route path="/:shortName/shopping-cart" exact>
                                        <CartViewerHeader />
                                        <CartViewer />
                                    </Route>
                                </Switch>
                            </ViewerLayout>
                        </Route>

                        {/* Organizer router */}
                        <Route
                            exact
                            path={[
                                '/:shortName/organizer/home',
                                '/:shortName/company-info',
                                '/:shortName/product-management',
                                '/:shortName/product-management/:companyId',
                                '/:shortName/product-register',
                                '/:shortName/advertisement-register',
                                '/:shortName/:productID/edit',
                                '/:shortName/seminar-management',
                                '/:shortName/seminar-management/:seminarId',
                                '/:shortName/faq',
                                '/:shortName/livestream-management',
                                '/:shortName/livestream-management/:id',
                                '/:shortName/setting-sell-product',
                            ]}
                        >
                            <UserLayout routes={organizerRoutes}>
                                <Switch>
                                    <Route path="/:shortName/organizer/home" exact component={HomePage} />
                                    <Route path="/:shortName/product-management" exact component={ProductManagement} />
                                    <Route path="/:shortName/product-management/:companyId" exact component={ProductManagementPreview} />
                                    <Route path="/:shortName/company-info" exact component={DetailCompanyOrganizer} />
                                    <Route path="/:shortName/product-register" exact component={ProductRegister} />
                                    <Route path="/:shortName/advertisement-register" exact component={AdvertisememtRegister} />
                                    <Route path="/:shortName/:productID/edit" exact component={ProductRegister} />
                                    <Route path="/:shortName/seminar-management" exact component={ListSeminar} />
                                    <Route path="/:shortName/seminar-management/:seminarId" exact component={ListSeminarPreview} />
                                    <Route path="/:shortName/faq" exact component={FAQ} />
                                    <Route path="/:shortName/livestream-management" exact component={ListLiveStreamOrganizer} />
                                    <Route path="/:shortName/livestream-management/:id" exact component={ListLiveStreamOrganizerPreview} />
                                    <Route path="/:shortName/setting-sell-product" exact component={SettingSellProductOrganizer} />
                                </Switch>
                            </UserLayout>
                        </Route>

                        {/* admin router */}
                        <Route
                            exact
                            path={[
                                '/admin/list-events',
                            ]}
                        >
                            <AdminLayout routes={baseSystems}>
                                <Switch>
                                    <Route path="/admin/list-events" exact component={ListEvents} />
                                </Switch>
                            </AdminLayout>
                        </Route>

                        {/* admin event router */}
                        <Route
                            exact
                            path={[
                                '/admin/:shortName/company-event-management',
                                '/admin/:shortName/all-seminar',
                                '/admin/:shortName/organizer-management',
                                '/admin/:shortName/setting-booth',
                                '/admin/:shortName/setting-seminar-room',
                                '/admin/:shortName/viewer-management',
                                '/admin/:shortName/survey-management',
                                '/admin/:shortName/register-seminar-management',
                                '/admin/:shortName/qa-management',
                                '/admin/:shortName/visit-history',
                                '/admin/:shortName/all-live-stream',
                                '/admin/:shortName/email-outer-server',
                                '/admin/:shortName/shopping-cart',
                                '/admin/:shortName/product-payment-management',
                                '/admin/:shortName/register-live-stream-management',
                                '/admin/:shortName/setting-custom',
                                '/admin/:shortName/setting-multi-language',
                            ]}
                        >
                            <AdminLayout routes={eventManagementSystem}>
                                <Switch>
                                    <Route path="/admin/:shortName/company-event-management" exact component={CompanyEventManagement} />
                                    <Route path="/admin/:shortName/shopping-cart" exact component={SettingShoppingCart} />
                                    <Route path="/admin/:shortName/all-seminar" exact component={ListAllSeminar} />
                                    <Route path="/admin/:shortName/organizer-management" exact component={ListOrganizer} />
                                    <Route path="/admin/:shortName/setting-seminar-room" exact component={SettingSeminarRoom} />
                                    <Route path="/admin/:shortName/setting-booth" exact component={SettingBooth} />
                                    <Route path="/admin/:shortName/viewer-management" exact component={ListViewer} />
                                    <Route path="/admin/:shortName/survey-management" exact component={SurverManagement} />
                                    <Route path="/admin/:shortName/register-seminar-management" exact component={ListRegisterSeminar} />
                                    <Route path="/admin/:shortName/register-live-stream-management" exact component={ListRegisterLiveStream} />
                                    <Route path="/admin/:shortName/product-payment-management" exact component={OrderProductPaymentManagement} />
                                    <Route path="/admin/:shortName/qa-management" exact component={QAListManagerment} />
                                    <Route path="/admin/:shortName/visit-history" exact component={VisitHistoryManagement} />
                                    <Route path="/admin/:shortName/all-live-stream" exact component={LiveStreamManagement} />
                                    <Route path="/admin/:shortName/email-outer-server" exact component={OuterServerMail} />
                                    <Route path="/admin/:shortName/setting-custom" exact component={SettingCustom} />
                                    <Route path="/admin/:shortName/setting-multi-language" exact component={SettingMultiLanguage} />
                                </Switch>
                            </AdminLayout>
                        </Route>

                        {/* admin company router */}
                        <Route
                            exact
                            path={[
                                '/admin/:shortName/:idCompany/seminar-management',
                                '/admin/:shortName/:idCompany/company-detail',
                                '/admin/:shortName/:idCompany/list-product-exhibition',
                                '/admin/:shortName/:idCompany/advertisement-management',
                                '/admin/:shortName/:idCompany/live-stream-management',
                                '/admin/:shortName/:idCompany/setting-product-company',
                                // '/admin/:shortName/:idCompany/visit-history',
                            ]}
                        >
                            <AdminLayout routes={companyMangementSystem}>
                                <Switch>
                                    <Route path="/admin/:shortName/:idCompany/company-detail" exact component={DetailCompany} />
                                    <Route path="/admin/:shortName/:idCompany/seminar-management" exact component={ListSeminars} />
                                    <Route path="/admin/:shortName/:idCompany/list-product-exhibition" exact component={ListProductExhibition} />
                                    <Route path="/admin/:shortName/:idCompany/advertisement-management" exact component={AdvertisementManagement} />
                                    <Route path="/admin/:shortName/:idCompany/live-stream-management" exact component={ListLiveStream} />
                                    <Route path="/admin/:shortName/:idCompany/setting-product-company" exact component={SettingProductCompany} />
                                    {/* <Route path="/admin/:shortName/:idCompany/visit-history" exact component={VisitHistoryManagement} /> */}
                                </Switch>
                            </AdminLayout>
                        </Route>
                        <Route component={ErrorPage} />
                    </Switch>
                </IntlProvider>
            </ConnectedRouter>
        </>
    );
};

App.defaultProps = {
    locale: '',
};

App.propTypes = {
    locale: PropTypes.string,
    getListOptionsRequested: PropTypes.func.isRequired,
    history: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
};
const mapStateToProps = (state) => ({
    isAuth: state.auth.credential.isAuthorized,
});

export default connect(mapStateToProps)(App);
